(function () {
  'use strict';
  /* Only one case type (e.g. Stride 2.0): nothing to choose, so hide the "Choose your case" block */
  var st = document.createElement('style');
  st.textContent = '.bsk-ct-static{display:none!important}.bsk-ct-opt:has(.bsk-ct-list>.bsk-ct:only-child){display:none!important}';
  document.head.appendChild(st);

  /* "Learn more" next to Choose your case jumps to the case-type comparison further down */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.bsk-ct-learn');
    if (!b) return;
    var target = document.getElementById('case-types');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
})();
